/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const Mailboxflagupsolid = (props) => (
  <Icon {...props} name="Mailboxflagupsolid">
    <path d="M9.4 4c-.333 0-.6.268-.6.6v2.8c0 .332.267.6.6.6s.6-.268.6-.6V6h1a.6.6 0 0 0 .6-.6v-.8c0-.333-.268-.6-.6-.6zm3.285-.515A4 4 0 0 1 15.2 7.2V12c0 .882-.717 1.6-1.6 1.6H2.4c-.882 0-1.6-.718-1.6-1.6V6.8c0-1.987 1.613-3.6 3.6-3.6h3.505c.22-.245.54-.4.895-.4h2.8c.477 0 .89.28 1.085.685M6.8 12V6.8a2.4 2.4 0 0 0-4.8 0V12c0 .22.18.4.4.4h4c.22 0 .4-.18.4-.4M3.4 6.8h2c.333 0 .6.267.6.6s-.268.6-.6.6h-2a.6.6 0 1 1 0-1.2" />
  </Icon>
);

export default Mailboxflagupsolid;
